import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { pushToDataLayer } from "../gaTracker";
import { getSectionCategorySubCat } from "../getSectionCategorySubCat";
export var ecommAdd = function ecommAdd(product) {
  var categories = getSectionCategorySubCat(product.detailLink);
  var ecommerceObj = {
    event: 'addToCart',
    ecommerce: {
      add: {
        currencyCode: 'USD',
        products: [_objectSpread(_objectSpread({}, product), {}, {
          section: categories[0] || '',
          category: categories[1] || '',
          'dimension1': categories[2] || '',
          'dimension2': categories[3] || '',
          'dimension3': 'In stock',
          'dimension4': '',
          'dimension5': (product === null || product === void 0 ? void 0 : product.catalog) || '',
          'dimension6': 'Regular Price',
          'variant': (product === null || product === void 0 ? void 0 : product.ProductVariantModel) || ''
        })]
      }
    }
  };
  pushToDataLayer(ecommerceObj);
};